webpackJsonp([22799509807079],{

/***/ 938:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _gatsbyImage = __webpack_require__(382);
	
	var _gatsbyImage2 = _interopRequireDefault(_gatsbyImage);
	
	var _Card = __webpack_require__(363);
	
	var _Card2 = _interopRequireDefault(_Card);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  var _caption;
	
	  return {
	    wrapper: {
	      border: '1px solid ' + theme.palette.borders.cloudier,
	      boxShadow: 'none'
	    },
	    caption: (_caption = {
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center'
	    }, _caption[theme.breakpoints.down('xs')] = {
	      fontSize: '0.9em'
	    }, _caption),
	    mentions: {
	      display: 'flex',
	      alignItems: 'center'
	    }
	  };
	};
	
	var SimpleCard = function SimpleCard(_ref) {
	  var classes = _ref.classes,
	      _ref$height = _ref.height,
	      height = _ref$height === undefined ? 300 : _ref$height,
	      thumbnail = _ref.thumbnail,
	      gatsbySizes = _ref.gatsbySizes,
	      gatsbyResolutions = _ref.gatsbyResolutions,
	      caption = _ref.caption,
	      title = _ref.title,
	      meta = _ref.meta;
	
	  var imageComponent = null;
	
	  if (!gatsbySizes && thumbnail) {
	    imageComponent = _react2.default.createElement(_Card.CardMedia, {
	      component: 'img',
	      src: thumbnail,
	      style: { height: height * 0.7 }
	    });
	  } else if (gatsbySizes && !thumbnail) {
	    imageComponent = _react2.default.createElement(_gatsbyImage2.default, {
	      style: { height: height * 0.7 }
	      // backgroundColor={theme.palette.primary.light}
	      , sizes: gatsbySizes,
	      alt: caption,
	      title: caption
	    });
	  } else if (gatsbyResolutions) {
	    imageComponent = _react2.default.createElement(_gatsbyImage2.default, {
	      style: { height: height * 0.7 },
	      resolutions: gatsbyResolutions,
	      alt: title,
	      title: title
	    });
	  }
	
	  return _react2.default.createElement(
	    _Card2.default,
	    { style: { height: height }, className: classes.wrapper, square: true },
	    imageComponent,
	    _react2.default.createElement(
	      _Typography2.default,
	      {
	        classes: { root: classes.caption },
	        style: { height: height * 0.1 },
	        variant: 'subheading'
	      },
	      caption
	    ),
	    _react2.default.createElement(
	      'div',
	      { className: classes.mentions, style: { height: height * 0.15 } },
	      _react2.default.createElement(
	        _Typography2.default,
	        { variant: 'caption', align: 'center', style: { width: '100%' } },
	        meta
	      )
	    )
	  );
	};
	
	SimpleCard.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  height: _propTypes2.default.number,
	  thumbnail: _propTypes2.default.string,
	  gatsbySizes: _propTypes2.default.object,
	  gatsbyResolutions: _propTypes2.default.object,
	  caption: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.node, _propTypes2.default.object]),
	  title: _propTypes2.default.string,
	  meta: _propTypes2.default.node
	
	  // prettier-ignore
	};exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles))(SimpleCard);
	module.exports = exports['default'];

/***/ }),

/***/ 981:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	exports.WeightLossWorkoutsPageQuery = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _Typography = __webpack_require__(11);
	
	var _Typography2 = _interopRequireDefault(_Typography);
	
	var _gatsbyLink = __webpack_require__(28);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _startCase = __webpack_require__(339);
	
	var _startCase2 = _interopRequireDefault(_startCase);
	
	var _compose = __webpack_require__(47);
	
	var _compose2 = _interopRequireDefault(_compose);
	
	var _withStyles = __webpack_require__(5);
	
	var _withStyles2 = _interopRequireDefault(_withStyles);
	
	var _Grid = __webpack_require__(41);
	
	var _Grid2 = _interopRequireDefault(_Grid);
	
	var _Button = __webpack_require__(42);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SimpleCard = __webpack_require__(938);
	
	var _SimpleCard2 = _interopRequireDefault(_SimpleCard);
	
	var _Phaser = __webpack_require__(132);
	
	var _Phaser2 = _interopRequireDefault(_Phaser);
	
	var _Meta = __webpack_require__(48);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var styles = function styles(theme) {
	  return {
	    container: {
	      padding: 20
	    },
	    header: {
	      border: '1px solid red'
	    },
	    mentionCount: {
	      color: theme.palette.accent.noticeLight,
	      fontSize: '1.2em',
	      fontWeight: 500
	    },
	    goButton: {
	      background: theme.palette.primary.main,
	      color: '#fff',
	      position: 'absolute',
	      right: 10,
	      bottom: -8
	    }
	  };
	};
	
	var WeightLossWorkoutsPage = function WeightLossWorkoutsPage(_ref) {
	  var classes = _ref.classes,
	      data = _ref.data;
	  var siteMetadata = data.site.siteMetadata;
	
	  var workouts = data.allMarkdownRemark.edges;
	  var markdownHtml = data.markdownRemark.html;
	  var thumbnails = data.allImageSharp.edges;
	
	  var thumbnailResolutions = thumbnails.reduce(function (acc, _ref2) {
	    var node = _ref2.node;
	    var originalName = node.resolutions.originalName;
	
	    var thumbName = originalName.slice(0, originalName.search(/\.(jpg|jpeg|png|gif)$/i));
	    if (!acc[thumbName]) acc[thumbName] = node.resolutions;
	    return acc;
	  }, {});
	
	  return _react2.default.createElement(
	    'div',
	    null,
	    _react2.default.createElement(_Meta.RootMeta, {
	      url: siteMetadata.siteUrl,
	      title: 'Workouts curated for Weight Loss | ' + siteMetadata.siteName,
	      description: 'Exercises known in the past to provide positive results for weight loss are assembled here. These exercises are actively formulated with weight loss in mind and were established by intensive research.',
	      breadCrumb: []
	    }),
	    _react2.default.createElement(
	      _Grid2.default,
	      { classes: { container: classes.container }, spacing: 24, container: true },
	      _react2.default.createElement(
	        _Grid2.default,
	        { xs: 12, item: true },
	        _react2.default.createElement(_Phaser2.default, { label: 'Workouts for Weight Loss', noBottom: true })
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { xs: 12, item: true },
	        _react2.default.createElement(_Typography2.default, { dangerouslySetInnerHTML: { __html: markdownHtml } }),
	        _react2.default.createElement(
	          _Typography2.default,
	          { style: { fontWeight: 500 } },
	          'Want to submit a mention? Click',
	          ' ',
	          _react2.default.createElement(
	            _gatsbyLink2.default,
	            { to: '/submit-mention' },
	            'here'
	          ),
	          '.'
	        )
	      ),
	      _react2.default.createElement(
	        _Grid2.default,
	        { xs: 12, item: true },
	        _react2.default.createElement(
	          _Grid2.default,
	          { spacing: 24, justify: 'center', container: true },
	          workouts.map(function (_ref3) {
	            var node = _ref3.node;
	
	            var name = node.fields.slug.replace(/\//g, '');
	            var resolutions = thumbnailResolutions[name];
	            var numMentions = Array.isArray(node.frontmatter.mentions) ? node.frontmatter.mentions.length : 0;
	            return _react2.default.createElement(
	              _Grid2.default,
	              { key: name, xs: 11, sm: 6, md: 4, lg: 3, xl: 2, item: true },
	              _react2.default.createElement(_SimpleCard2.default, {
	                height: 250,
	                gatsbyResolutions: resolutions,
	                caption: _react2.default.createElement(
	                  _gatsbyLink2.default,
	                  { to: node.fields.slug },
	                  (0, _startCase2.default)(name)
	                ),
	                title: (0, _startCase2.default)(name),
	                meta: _react2.default.createElement(
	                  'div',
	                  { style: { fontWeight: 500, position: 'relative' } },
	                  'Mentioned',
	                  ' ',
	                  _react2.default.createElement(
	                    'span',
	                    { className: classes.mentionCount },
	                    numMentions
	                  ),
	                  ' ',
	                  'times',
	                  _react2.default.createElement(
	                    _gatsbyLink2.default,
	                    { to: node.fields.slug },
	                    _react2.default.createElement(
	                      _Button2.default,
	                      {
	                        classes: { root: classes.goButton },
	                        size: 'small',
	                        variant: 'raised'
	                      },
	                      'Go'
	                    )
	                  )
	                )
	              })
	            );
	          })
	        )
	      )
	    )
	  );
	}; //
	
	WeightLossWorkoutsPage.propTypes = {
	  classes: _propTypes2.default.object.isRequired,
	  data: _propTypes2.default.object
	
	  // prettier-ignore
	  // eslint-disable-next-line
	};var WeightLossWorkoutsPageQuery = exports.WeightLossWorkoutsPageQuery = '** extracted graphql fragment **';
	
	// prettier-ignore
	exports.default = (0, _compose2.default)((0, _withStyles2.default)(styles))(WeightLossWorkoutsPage);

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-weight-loss-workouts-js-c63d0ef14155829ce1c7.js